import { DCUIContent } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import {
    DCUIThemingStartPageCaptureStepValidationErrors,
    DCUIThemingStartPageValidationErrors
} from "@idw-types/common/validation/common/dcui-theming-validation-errors";
import { DCUIThemingStep } from "@idw-types/common/dcui/dcui-theming-step";

export const getDCUIThemingStartPageValidationErrors = (
    isUsingDCUIVersion2: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    documentCaptureSteps: Array<DCUIThemingStep>,
    dcuiContent: DCUIContent
): DCUIThemingStartPageValidationErrors => {
    let count = 0;
    let headlineError = null;
    let explanationError = null;

    const defaultCaptureStepErrors: DCUIThemingStartPageCaptureStepValidationErrors = {
        captureStepLabelError: null,
        captureStepImageURLError: null
    };
    const captureStepErrors = {
        face: { ...defaultCaptureStepErrors },
        dlfront: { ...defaultCaptureStepErrors },
        dlback: { ...defaultCaptureStepErrors },
        idfront: { ...defaultCaptureStepErrors },
        idback: { ...defaultCaptureStepErrors },
        passport: { ...defaultCaptureStepErrors }
    };

    let startButtonTextError = null;
    let startButtonLoadingTextError = null;

    if (isUsingDCUIVersion2 && hasDisplayableDocumentCaptureAttributes) {
        if (!dcuiContent.start.headline) {
            count += 1;
            headlineError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent.start.explanationHtml) {
            count += 1;
            explanationError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }

        documentCaptureSteps.forEach(dcs => {
            const stepContent = dcuiContent[dcs.stepType];
            if (!stepContent.label) {
                count += 1;
                captureStepErrors[dcs.stepType].captureStepLabelError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
            }
            if (stepContent.useCustomStartInstructionImage && !stepContent.startInstructionsImageUrl) {
                count += 1;
                captureStepErrors[dcs.stepType].captureStepImageURLError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
            }
        });

        if (!dcuiContent.start.buttonText) {
            count += 1;
            startButtonTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent.start.loadingButtonText) {
            count += 1;
            startButtonLoadingTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
    }

    return {
        headlineError,
        explanationError,
        ...captureStepErrors,
        startButtonTextError,
        startButtonLoadingTextError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.startPage.tabName}
            errorCount={count}
        />
    };
};